import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import MainContent from './components/MainContent';
import Footer from './components/Footer';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import { PayrollProvider } from './context/PayrollContext';

function App() {
  return (
    <PayrollProvider>
      <Router>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<MainContent />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </PayrollProvider>
  );
}

export default App;